export default __webpack_public_path__ + "static/media/hamilton.9f863f85.jpg";